// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__fIAic","container":"DefaultLayout_container__jhyi3"};